import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useOutsideClicker } from 'libs/hooks';
import { BlueButton, GrayButton } from 'libs/ui';
import { SimpleModal, SimpleModalButtons, SimpleModalTitle } from '../simple-modal/simple-modal';
import { Content } from './confirm.styled';

export const Confirm = (props) => {
  const { t } = useTranslation();
  const { title, children, close, action, closeTitle, actionTitle, actionDisabled, above, arrowPos, topPos } = props;
  const ref = useRef();

  useOutsideClicker(ref, () => {
    close();
  });

  const handleCancel = () => {
    close();
  };

  const handleAction = () => {
    action && !actionDisabled && action();
  };

  const actionOther = {};
  if (actionDisabled) {
    actionOther.disabled = true;
  }

  return (
    <SimpleModal className="confirm" $above={above} $arrowPos={arrowPos} $topPos={topPos} ref={ref}>
      <SimpleModalTitle>{title}</SimpleModalTitle>
      <Content>{children}</Content>
      <SimpleModalButtons>
        <GrayButton className="btn" onClick={handleCancel}>
          {closeTitle || t('buttons.Отмена')}
        </GrayButton>
        {actionTitle && (
          <BlueButton className="btn" onClick={handleAction} {...actionOther}>
            {actionTitle}
          </BlueButton>
        )}
      </SimpleModalButtons>
    </SimpleModal>
  );
};
